import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from '@app/shared/button/button.module';
import { TermsAndConditionsContentComponent } from './terms-and-conditions-content.component';
import { TranslateModule } from '@ngx-translate/core';
import { LoadingSpinnerModule } from '@app/shared/spinner/loading-spinner.module';
import { UtilsModule } from '@app/shared/utils/utils-module';

@NgModule({
  declarations: [TermsAndConditionsContentComponent],
  imports: [
    CommonModule,
    ButtonModule,
    TranslateModule,
    LoadingSpinnerModule,
    UtilsModule
  ],
  exports:[TermsAndConditionsContentComponent]
})
export class TermsAndConditionsContentModule { }
